import get from 'lodash/get'
import * as Sentry from '@sentry/browser'

// Requests
import { getRecommendations } from '../api/mikasa/requests'

// ActionTypes
import { FETCH_RECOMMENDATIONS, FETCH_RECOMMENDATIONS_SUCCESS, FETCH_RECOMMENDATIONS_FAILURE } from './actionTypes'

export const fetchRecommendations = (clientId, homeUuid) => async dispatch => {
  dispatch({ type: FETCH_RECOMMENDATIONS })

  try {
    const res = await getRecommendations({ clientId, homeUuid })
    const data = get(res, 'data.data', [])
    dispatch({
      type: FETCH_RECOMMENDATIONS_SUCCESS,
      data
    })
  } catch (error) {
    Sentry.captureException(error)
    dispatch({
      type: FETCH_RECOMMENDATIONS_FAILURE,
      error
    })
  }
}
